import React from "react";
import {
  Grid,
  makeStyles,
  Typography,
  Select,
  MenuItem
} from "@material-ui/core";

const useStyles = makeStyles(() => ({
  selectRoot: {
    fontWeight: 400,
    fontSize: 14,
    textTransform: "capitalize"
  },
  selectIcon: {
    right: -2
  }
}));

function SelectBox({
  options,
  label,
  setValue,
  containerStyle,
  defaultValue,
  value,
  selectRoots = ""
}) {
  const classes = useStyles();

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <Grid
      container
      alignItems="baseline"
      justifyContent="flex-end"
      wrap="nowrap"
    >
      {label && (
        <Typography
          variant="subtitle2"
          className={classes.selectRoot}
          classes={selectRoots}
          style={{ marginRight: 10 }}
        >
          {label}
        </Typography>
      )}
      <Select
        labelId="label"
        id="select"
        autoWidth={true}
        defaultValue={defaultValue ? defaultValue : " "}
        onChange={handleChange}
        disableUnderline
        value={value}
        classes={{
          root: classes.selectRoot,
          icon: `${classes.selectIcon} ${selectRoots}`
        }}
        renderValue={() => defaultValue}
        style={containerStyle}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.label.toLowerCase()}
            style={{ fontSize: 12 }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
}

export default SelectBox;
